<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="11"
    :class="{'icon-check_disabled': disabled}"
    fill="none">
    <path class="svg-colorized-el__stroke" id="icon-check_fill" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 4l6 6 9-9"/>
  </svg>
</template>

<script>
export default {
  props: {
    disabled: Boolean,
  },
};
</script>

<style lang="scss" scoped>
  .icon-check_disabled {
    #icon-check_fill {
      fill: $grey-color2;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/icons/IconCheck.vue